module.exports = __webpack_public_path__ + "img/kodluyoruz.401236e9.png";